/* tslint:disable */
/* eslint-disable */
/**
 * OasisExplorer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorReward
 */
export interface ValidatorReward {
    /**
     * 
     * @type {number}
     * @memberof ValidatorReward
     */
    block_level?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidatorReward
     */
    epoch?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidatorReward
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidatorReward
     */
    created_at?: number;
}

export function ValidatorRewardFromJSON(json: any): ValidatorReward {
    return ValidatorRewardFromJSONTyped(json, false);
}

export function ValidatorRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorReward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'block_level': !exists(json, 'block_level') ? undefined : json['block_level'],
        'epoch': !exists(json, 'epoch') ? undefined : json['epoch'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function ValidatorRewardToJSON(value?: ValidatorReward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'block_level': value.block_level,
        'epoch': value.epoch,
        'amount': value.amount,
        'created_at': value.created_at,
    };
}


